import { createContext } from 'react';
const GroupContext = createContext({});

export default GroupContext;
